import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Filter = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Filter({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14 6.5C14 8.70914 12.2091 10.5 10 10.5C8.04553 10.5 6.41846 9.09824 6.0693 7.24524C6.04665 7.24838 6.02351 7.25 6 7.25H2.5C2.22386 7.25 2 7.02614 2 6.75V6.25C2 5.97386 2.22386 5.75 2.5 5.75H6C6.02351 5.75 6.04665 5.75162 6.0693 5.75476C6.41846 3.90176 8.04553 2.5 10 2.5C12.2091 2.5 14 4.29086 14 6.5ZM12.5 6.5C12.5 7.88071 11.3807 9 10 9C8.61929 9 7.5 7.88071 7.5 6.5C7.5 5.11929 8.61929 4 10 4C11.3807 4 12.5 5.11929 12.5 6.5Z'
        fill={color}
      />
      <path
        d='M22 6.75C22 7.02614 21.7761 7.25 21.5 7.25H16C15.7239 7.25 15.5 7.02614 15.5 6.75V6.25C15.5 5.97386 15.7239 5.75 16 5.75H21.5C21.7761 5.75 22 5.97386 22 6.25V6.75Z'
        fill={color}
      />
      <path
        d='M9 17.75C9 18.0261 8.77614 18.25 8.5 18.25H2.5C2.22386 18.25 2 18.0261 2 17.75V17.25C2 16.9739 2.22386 16.75 2.5 16.75H8.5C8.77614 16.75 9 16.9739 9 17.25V17.75Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22 17.75C22 18.0261 21.7761 18.25 21.5 18.25H18C17.9765 18.25 17.9534 18.2484 17.9307 18.2452C17.5815 20.0982 15.9545 21.5 14 21.5C11.7909 21.5 10 19.7091 10 17.5C10 15.2909 11.7909 13.5 14 13.5C15.9545 13.5 17.5815 14.9018 17.9307 16.7548C17.9534 16.7516 17.9765 16.75 18 16.75H21.5C21.7761 16.75 22 16.9739 22 17.25V17.75ZM14 20C15.3807 20 16.5 18.8807 16.5 17.5C16.5 16.1193 15.3807 15 14 15C12.6193 15 11.5 16.1193 11.5 17.5C11.5 18.8807 12.6193 20 14 20Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'filter-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Filter;
